import React from "react";
import Manager from "../../../../../components/Manager";
import { useRedEnvelope } from "../../redEnvelope/RedEnvelopeContext";

// subType=7 红包
export default function RedPacketMessage({ msg }) {
  const { attach } = msg;
  const { envelopeStatuses, getRedEnvelopeInfo, openRedEnvelopeAlert, handleRecord, updateEnvelopeStatus } = useRedEnvelope();
  const isOpened = envelopeStatuses[attach?.redenvelope_id]?.opened;
  return (
    <div
      className="imc-redpack"
      style={{ backgroundColor: isOpened ? "#EC7C78" : "#DD342F" }}
      onClick={() => {
        getRedEnvelopeInfo(attach.redenvelope_id).then((data) => {
          Manager.push({ data: attach?.event_id });
          if (data.is_pop_bullet) openRedEnvelopeAlert(data);
          else {
            updateEnvelopeStatus(data, true);
            handleRecord(data);
          }
        });
      }}
    >
      <div className="imc-redpack-body">
        <img
          src={"resources/251222/" + (isOpened ? "re_receive" : "re_big") + ".png"}
          alt=""
          height={44}
        />
        <div className="imc-redpack-info">
          <div className="imc-redpack-name">{attach?.title}</div>
          <div className="imc-redpack-hint">查看详情</div>
        </div>
      </div>
      <div className="imc-redpack-divider" />
      <div className="imc-redpack-desc">{attach?.task_desc}</div>
    </div>
  );
}
